import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaiairportcab() {



const cardData = {
  keyword: " Navi Mumbai Airport Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Navi Mumbai Airport cab services for travelers looking for hassle-free transportation to and from Navi Mumbai International Airport. Whether you are catching a flight, returning from a trip, or traveling for business or leisure, our cab service ensures timely pickups, smooth rides, and a stress-free airport experience. We offer flexible booking options including one-way, round-trip, and hourly packages with transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs experienced in navigating Mumbai’s and Navi Mumbai’s roads, well-maintained vehicles, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai Airport cab services.",

topPlaces: [
  {
    title: "DY Patil Stadium",
    description:
      "DY Patil Stadium is a prominent sports and entertainment venue in Navi Mumbai, known for hosting cricket matches, football games, and large-scale events. Visitors can attend live sports events or concerts while enjoying modern amenities and comfortable seating. A cab ride from Navi Mumbai Airport provides convenient and timely access, ensuring you reach the stadium without worrying about parking or traffic delays."
  },
  {
    title: "Central Park, Kharghar",
    description:
      "Central Park in Kharghar is one of the largest green spaces in Navi Mumbai, featuring well-maintained walking paths, gardens, fountains, and recreational areas. Families, fitness enthusiasts, and tourists visit for morning walks, picnics, and relaxation. Traveling by cab from Navi Mumbai Airport allows visitors to comfortably explore the park without the hassle of local transport or navigation."
  },
  {
    title: "Pandavkada Falls",
    description:
      "Pandavkada Falls is a scenic waterfall located near Kharghar, ideal for nature lovers and adventure seekers. Visitors can enjoy trekking, photography, and the serene natural surroundings. A cab from Navi Mumbai Airport ensures safe and convenient access to this picturesque destination, making it suitable for day trips or nature excursions."
  },
  {
    title: "Kharghar Hills",
    description:
      "Kharghar Hills offer panoramic views of Navi Mumbai and are popular for hiking, photography, and birdwatching. Visitors enjoy nature trails and the tranquil atmosphere. Hiring a cab from Navi Mumbai Airport provides a comfortable and direct journey to the hills, making it easy to include this destination in your itinerary without worrying about traffic or parking."
  },
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historic fortification located in Navi Mumbai, offering insights into the region’s history and architecture. Visitors can explore the fort, enjoy scenic views, and learn about its historical significance. A cab ride from the airport allows tourists to comfortably visit the fort as part of their sightseeing plans."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is a modern shopping and entertainment destination in Navi Mumbai, featuring retail stores, food courts, cinemas, and recreational activities. Families and travelers can shop, dine, and enjoy leisure activities. A cab service from Navi Mumbai Airport ensures a smooth and convenient ride directly to this shopping hub."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a landmark in Navi Mumbai known for its beautiful architecture, gardens, and surrounding commercial areas. It is popular for photography and casual sightseeing. Traveling by cab from Navi Mumbai Airport allows visitors to reach Utsav Chowk comfortably and include it in a broader city tour."
  },
  {
    title: "Khandeshwar Temple",
    description:
      "Khandeshwar Temple is a religious site in Navi Mumbai dedicated to Lord Shiva. Devotees and tourists visit for prayers and to experience the spiritual ambiance. A cab ride from the airport provides easy and convenient access, allowing travelers to include this temple in their Navi Mumbai itinerary without hassle."
  },
  {
    title: "Shivaji Udyan",
    description:
      "Shivaji Udyan is a well-maintained park offering green spaces, walking tracks, and recreational areas suitable for families and children. Visitors can relax, enjoy picnics, and spend quality time outdoors. Traveling by cab from Navi Mumbai Airport ensures convenient access and a comfortable journey to this park."
  },
  {
    title: "Palm Beach Road",
    description:
      "Palm Beach Road is a scenic and well-planned stretch in Navi Mumbai, ideal for leisurely drives and city sightseeing. The road connects various residential, commercial, and recreational areas. Hiring a cab from Navi Mumbai Airport offers travelers a comfortable and smooth ride along this popular route, making it easier to explore the city’s highlights."
  }
],



services: [
{
name: "Navi Mumbai Airport Cab",
description: "Navi Mumbai Airport cab service provides reliable and comfortable transportation for passengers traveling to or from Navi Mumbai International Airport. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles designed for smooth airport transfers. Professional drivers ensure punctual pickup and safe travel across Mumbai and Navi Mumbai. Pickup is available from homes, hotels, offices, railway stations, and business hubs. Spacious seating and luggage space make airport travel convenient for families and corporate travelers. Ideal for domestic and international flight transfers. Transparent pricing and dependable service make your airport journey stress-free."
},
{
name: "Navi Mumbai Airport Taxi",
description: "Navi Mumbai Airport taxi service offers dependable transportation for passengers traveling between the city and the airport. Our vehicles provide comfortable seating and smooth ride quality suitable for airport transfers. Experienced drivers monitor flight schedules to ensure timely pickup and drop services. Pickup is available from all areas of Mumbai, Thane, and Navi Mumbai. Air-conditioned vehicles ensure comfortable travel even during long traffic hours. Ideal for business travelers, tourists, and family airport trips. Easy booking options make travel planning simple."
},
{
name: "Navi Mumbai Airport Cab Service",
description: "Navi Mumbai Airport cab service provides safe and convenient transportation for travelers heading to the airport. Our professional drivers ensure timely arrival so passengers never miss their flights. Vehicles are clean, well-maintained, and equipped with comfortable seating and luggage capacity. Pickup services are available from homes, hotels, offices, railway stations, and major business districts. Air-conditioned vehicles provide comfortable travel throughout the journey. Ideal for corporate travelers, tourists, and family airport transfers."
},
{
name: "Cab for Navi Mumbai Airport",
description: "Cab for Navi Mumbai Airport offers reliable transportation for passengers needing convenient airport transfers. Our vehicles provide comfortable seating and smooth ride performance suitable for city travel. Professional drivers ensure punctual pickup services and safe driving throughout the journey. Pickup services are available across Mumbai, Navi Mumbai, and Thane. Ideal for airport pickups, flight departures, and corporate travel needs. Comfortable vehicles and professional service make airport travel stress-free."
},
{
name: "Taxi for Navi Mumbai Airport",
description: "Taxi for Navi Mumbai Airport provides convenient city-to-airport transportation for travelers and business passengers. Vehicles offer comfortable seating and reliable ride performance suitable for airport journeys. Professional drivers ensure safe travel and punctual pickup services from homes, offices, hotels, and railway stations. Ideal for domestic and international flight transfers. Flexible booking options allow passengers to easily schedule rides."
},
{
name: "Navi Mumbai Airport Pickup Cab",
description: "Navi Mumbai Airport pickup cab service provides reliable transportation for passengers arriving at the airport. Drivers track flight schedules to ensure timely pickup even if flights are delayed. Vehicles provide comfortable seating and sufficient luggage space for travelers. Pickup services are available for hotels, homes, and business locations across Mumbai and Navi Mumbai. Ideal for tourists, corporate travelers, and family airport transfers."
},
{
name: "Navi Mumbai Airport Drop Taxi",
description: "Navi Mumbai Airport drop taxi service provides timely transportation for passengers departing from the airport. Professional drivers ensure punctual pickups so travelers reach the airport well before their flight time. Vehicles offer comfortable seating and air-conditioned interiors for smooth travel. Pickup is available from homes, offices, hotels, and railway stations across the city."
},
{
name: "Navi Mumbai Airport Cab Booking",
description: "Navi Mumbai Airport cab booking allows passengers to easily reserve vehicles for convenient airport transportation. Online and phone booking options provide instant confirmation and flexible scheduling. Vehicles provide comfortable seating and reliable travel suitable for airport transfers. Professional drivers ensure punctual pickup services across Mumbai and Navi Mumbai."
},
{
name: "Navi Mumbai Airport Taxi Booking Online",
description: "Navi Mumbai Airport taxi booking online provides fast and convenient reservations for passengers traveling to the airport. Travelers can easily schedule their ride online and receive instant booking confirmation. Vehicles provide comfortable seating and smooth ride performance suitable for airport journeys."
},
{
name: "Cheap Navi Mumbai Airport Cab",
description: "Cheap Navi Mumbai Airport cab service provides economical airport transportation without compromising comfort or safety. Passengers can enjoy clean vehicles, professional drivers, and reliable service at affordable pricing. Ideal for budget travelers, students, and daily commuters needing airport transfers."
},
{
name: "Best Navi Mumbai Airport Taxi Service",
description: "Best Navi Mumbai Airport taxi service provides premium transportation for passengers looking for reliable and professional airport travel. Vehicles offer spacious seating, smooth ride quality, and comfortable interiors. Professional drivers ensure punctual pickups and safe travel throughout the journey."
},
{
name: "Navi Mumbai Airport Cab Near Me",
description: "Navi Mumbai Airport cab near me service allows passengers to quickly find available airport transportation nearby. Our network of vehicles ensures fast pickup services from homes, offices, and hotels across the city. Comfortable vehicles and professional drivers ensure reliable airport travel."
},
{
name: "24x7 Navi Mumbai Airport Cab",
description: "24x7 Navi Mumbai Airport cab service provides round-the-clock transportation for passengers traveling at any time of the day or night. Whether early morning flights or late-night arrivals, our drivers are always available to provide reliable airport transfers."
},
{
name: "Navi Mumbai Airport Innova Cab",
description: "Navi Mumbai Airport Innova cab service provides spacious MPV transportation ideal for families and groups traveling with luggage. The Toyota Innova offers comfortable seating and smooth ride quality suitable for airport journeys. Professional drivers ensure punctual pickups and safe driving."
},
{
name: "Navi Mumbai Airport Sedan Taxi",
description: "Navi Mumbai Airport sedan taxi service provides economical and comfortable transportation for airport travelers. Sedan vehicles offer smooth ride quality and air-conditioned interiors suitable for city travel. Ideal for individual travelers and small families needing convenient airport transfers."
}
],

tableData: [
["Navi Mumbai Airport Cab","Navi Mumbai Airport Taxi"],
["Navi Mumbai Airport Cab Service","Cab for Navi Mumbai Airport"],
["Taxi for Navi Mumbai Airport","Navi Mumbai Airport Pickup Cab"],
["Navi Mumbai Airport Drop Taxi","Navi Mumbai Airport Cab Booking"],
["Navi Mumbai Airport Taxi Booking Online","Cheap Navi Mumbai Airport Cab"],
["Best Navi Mumbai Airport Taxi Service","Navi Mumbai Airport Cab Near Me"],
["24x7 Navi Mumbai Airport Cab","Navi Mumbai Airport Innova Cab"],
["Navi Mumbai Airport Sedan Taxi","Airport Transfer Navi Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Airport Transfer Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in airport transfers across Navi Mumbai including the new Navi Mumbai International Airport routes. They understand flight schedules, traffic conditions, and the fastest routes ensuring timely pickup and drop services."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Navi Mumbai Airport cab bookings. Customers receive clear information about travel fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport cab service operates 24 hours a day. Whether you have an early morning departure or a late-night flight arrival, we provide reliable airport transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable airport transfer experience."
  },
  {
    WhyChooseheading: "Flexible Airport Transfer Options",
    WhyChoosedescription: "We provide flexible airport transfer services including one-way airport drop, airport pickup, round-trip airport travel, and corporate airport transportation."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai & Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and business locations across Mumbai and Navi Mumbai for seamless airport transfers."
  },
  {
    WhyChooseheading: "Reliable Airport Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for reliable Navi Mumbai Airport cab services. Our punctual drivers, comfortable vehicles, and professional service ensure stress-free airport travel."
  }
]
};

const faqData = [
  { question: "Do you provide cab service to Navi Mumbai Airport?", answer: "Yes, Omshree Cabs provides reliable cab services to and from Navi Mumbai Airport for both pickup and drop." },
  { question: "Is the Navi Mumbai Airport cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight arrival and departure schedules." },
  { question: "Which vehicles are available for airport transfers?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Can I book a cab for airport pickup?", answer: "Yes, we provide airport pickup services where drivers wait for passengers at the arrival terminal." },
  { question: "Do you provide cab service from Mumbai city to Navi Mumbai Airport?", answer: "Yes, we provide airport transfer services from all areas of Mumbai including South Mumbai, Western Suburbs, and Central Suburbs." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable airport travel." },
  { question: "Do drivers track flight arrival times?", answer: "Yes, our drivers monitor flight schedules to ensure timely pickup even if the flight is delayed." },
  { question: "Is advance booking recommended for airport travel?", answer: "Yes, advance booking is recommended to ensure timely airport transfers especially during peak travel hours." },
  { question: "Can corporate clients book airport transfers?", answer: "Yes, we provide dedicated airport transfer services for corporate travelers and business executives." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "We booked Omshree Cabs for a Navi Mumbai Airport pickup. The driver arrived on time and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback:
      "Excellent airport cab service. Smooth transfer to Navi Mumbai Airport with a clean car and professional driver.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Navi Mumbai Airport Cab",
  "description": "Reliable and affordable Navi Mumbai Airport cab service with Omshree Cab. We offer airport pickups, drop-offs, one-way or round trips with Innova, sedan, and luxury cabs. Book online 24x7 for safe and comfortable transfers.",
  "provider": {
    "@type": "Organization",
    "name": "Omshree Cab",
    "telephone": "+91 9892544084",
    "url": "https://www.omshreecab.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": "Airport Cab Service"
};





  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai Airport Cab | 24x7 Pickup & Drop | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai Airport cab with Omshree Cab for pickups and drops. Choose Innova, sedan, or luxury cabs for one-way or round trips. Safe, affordable, and 24x7 online booking available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairportcab;